// extracted by mini-css-extract-plugin
export var black = "_4n-6";
export var brand = "_4n-1";
export var ddefault = "_4n-0";
export var error = "_4n-3";
export var gray = "_4n-2";
export var highContrast = "_4n-8";
export var outline = "_4n-7";
export var success = "_4n-5";
export var warning = "_4n-4";